
export const getBaseAddress = () => {
    return process.env.VUE_APP_BASE_ADDRESS + "/api/v2/";
}
